<ion-header>
  <ion-toolbar>
    <ion-title>Zonas</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tecservice-transportec/transportec" color="primary"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-list *ngIf="!zones && loadingZones">
    <ion-item *ngFor="let item of [0,1,2,3,4,5,6,7,8]">
      <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
    </ion-item>
  </ion-list>
  <ion-list>
    <ion-item *ngFor="let z of zones; let i = index" (click)="goRoutes(z)">{{z.name}}</ion-item>
  </ion-list>
</ion-content>
